import React from "react";
import Grid from "@mui/material/Grid";
import { brandColors } from "../../_components/brandedComponent/BrandedColors";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { LifeSafer } from "../../_helpers/BrandConstants";
import Cookies from "universal-cookie";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PropTypes from "prop-types";
import BeatLoader from "react-spinners/BeatLoader";
import Typography from "@mui/material/Typography";
import Box from "@mui/system/Box";
import { useParams } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const ContinueButton = ({
  goToBackStep,
  submitting,
  onClick,
  continueText = "steps.continue",
  continueButtonShow = true,
  isLongWidth,
  isStatic,
  isFullWidth,
  isFullLeftRightWidth,
  showForwardIcon = true,
  startIcon,
  showSavingIndicator = true,
}) => {
  const cookies = new Cookies();
  const { storyName } = useParams();

  const { t } = useTranslation();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const enrolleeUser = JSON.parse(sessionStorage.getItem("enrolleeUser"));
  const isSpeedStory =
    storyName === "speed" || storyName?.toLowerCase() === "isa volunteer";
  const isLocationStory =
    storyName === "location" || storyName?.toLowerCase() === "location";
  const isPartnerStory =
    storyName === "partner" || storyName?.toLowerCase() === "partner";
  const isVehicleStep =
    enrolleeUser?.step === "Vehicle" || enrolleeUser?.step === "Pricing";
  const continueBackgroundColor =
    storyName === "speed" || storyName?.toLowerCase() === "isa volunteer"
      ? "#76bc21"
      : brandColors[brand].secondary;
  const continueButtonTextColor =
    storyName?.toLowerCase() === "speed" ||
    storyName?.toLowerCase() === "isa volunteer" ||
    storyName?.toLowerCase() === "location" ||
    storyName?.toLowerCase() === "partner" || storyName?.toLowerCase() === "europe"
      ? "#1c355e"
      : "";
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleBack = () => {
    goToBackStep();
  };

  return (
    <>
      <Grid
        style={{
          width: "100%",
          position: isMobile && !isStatic ? "fixed" : "",
          bottom: 0,
          backgroundColor: isMobile ? "#fff" : "transparent",
          paddingTop: isMobile ? "10px" : "0px",
          paddingBottom: isMobile ? "10px" : "0px",
          zIndex: isMobile ? 1000 : "auto",
          left: 0,
          boxShadow:
            isMobile && !isStatic ? "0px -2px 10px rgba(0, 0, 0, 0.1)" : "none",
        }}
      >
        <Grid
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Grid
            sx={{
              display: "flex",
              // width: "80%",
              width:
                enrolleeUser?.step === "WhyIsa"
                  ? "100%"
                  : isFullLeftRightWidth
                    ? "100%"
                    : "auto",
              paddingX: enrolleeUser?.step === "WhyIsa" ? "10px" : "auto",
              minWidth:
                isSpeedStory && isVehicleStep
                  ? { xs: "300px", sm: "300px", lg: "700px" }
                  : "300px",
              justifyContent: "space-around",
              alignItems: "center",
              maxWidth:
                isSpeedStory && isVehicleStep
                  ? { xs: "480px", sm: "480px", lg: "700px" }
                  : "480px",
            }}
          >
            {!submitting || !showSavingIndicator ? (
              <>
                {goToBackStep && (
                  <Button
                    sx={{
                      color: `${brandColors[brand].primary}`,
                      fontWeight: "bold",
                    }}
                    variant="text"
                    onClick={handleBack}
                    disabled={submitting}
                    // sx={{ fontWeight: "bold" }}
                  >
                    {t("steps.back")}
                  </Button>
                )}
                {continueButtonShow && (
                  <Button
                    variant="contained"
                    type={onClick ? "button" : "submit"}
                    size="medium"
                    onClick={onClick}
                    startIcon={startIcon}
                    disabled={submitting}
                    sx={{
                      width: isLongWidth
                        ? {
                            xs: isFullWidth ? "100%" : "auto",
                            md: isFullWidth ? "100%" : "auto",
                            lg: 300,
                          }
                        : isFullLeftRightWidth
                          ? { xs: "85%", sm: "85%", md: "85%", lg: "85%" }
                          : "auto",
                    }}
                    style={{
                      backgroundColor: `${continueBackgroundColor}`,
                      color: `${continueButtonTextColor}`,
                      fontWeight: "bold",
                    }}
                    endIcon={
                      <span style={{ display: "flex", fontWeight: "bold" }}>
                        {showForwardIcon &&
                          !isPartnerStory &&
                          (isLocationStory ? (
                            <ArrowForwardIosIcon
                              sx={{ width: "16px", height: "16px" }}
                              color="primary"
                            />
                          ) : (
                            <ArrowForwardIcon />
                          ))}
                      </span>
                    }
                  >
                    {t(continueText)}
                  </Button>
                )}
              </>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ fontWeight: "600", fontSize: "20px" }}>
                  {t("steps.saving")}
                </Typography>
                <BeatLoader color="#76bc21" />
              </Box>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

ContinueButton.propTypes = {
  goToBackStep: PropTypes.func,
  submitting: PropTypes.bool,
  onClick: PropTypes.func,
  continueText: PropTypes.string,
  continueButtonShow: PropTypes.bool,
  isLongWidth: PropTypes.bool,
  isStatic: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  isFullLeftRightWidth: PropTypes.bool,
  showForwardIcon: PropTypes.bool,
  startIcon: PropTypes.node,
  showSavingIndicator: PropTypes.bool,
};
export default ContinueButton;
